import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=a253ef12&scoped=true"
import script from "./transform.vue?vue&type=script&lang=js"
export * from "./transform.vue?vue&type=script&lang=js"
import style0 from "./transform.vue?vue&type=style&index=0&id=a253ef12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a253ef12",
  null
  
)

export default component.exports